var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ViewLoadingMessage',{attrs:{"extra-class":'py-5',"loading":_vm.loading,"size":"sm"}}),(!_vm.loading)?_c('Bar',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartData.options}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }